import PropTypes from 'prop-types'
import StrokeSpinner from '@/assets/icons/stroke-spinner'

const PlaidLoadingScreen = ({ isProcessingTransactions = false }) => {
  const header = isProcessingTransactions
    ? 'Processing transactions to identify eligible loan and lease payments...'
    : 'Connecting your account...'

  return (
    <div className="fixed inset-0 bg-gray-950 bg-opacity-70 flex justify-center items-center z-50 p-4">
      <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-lg flex flex-col justify-center items-center max-w-[92%] md:max-w-[480px] w-full">
        {/* Custom Plaid-specific loading content */}
        <div className="text-center mb-4">
          <h3 className="text-lg font-semibold text-gray-900 mb-2" style={{ fontSize: '18px', fontWeight: 600 }}>
            {header}
          </h3>
        </div>

        {/* Spinner with rectangle outline */}
        <div className="rounded-lg border border-gray-200 w-[50px] p-1 flex justify-center items-center mx-auto mb-4">
          <StrokeSpinner />
        </div>

        {/* Progress indicator */}
        <div className="mt-4 text-base font-normal text-gray-600 text-center mb-5">
          This may take a moment. Please do not press the back button
          or refresh your browser.
        </div>
      </div>
    </div>
  )
}

PlaidLoadingScreen.propTypes = {
  isProcessingTransactions: PropTypes.bool,
}

export default PlaidLoadingScreen 